import { combineReducers } from 'redux';

import core from 'Core/.globals/redux/reducers';
import accounts from 'Modules/accounts/.globals/redux/reducers';
import devices from 'Modules/devices/.globals/redux/reducers';
import activities from 'Modules/activities/.globals/redux/reducers';
import rawData from 'Modules/rawData/.globals/redux/reducers';
import pmUsers from 'Modules/pmUsers/.globals/redux/reducers';
import vidfleet from 'Modules/vidfleet/.globals/redux/reducers';
import transactions from 'Modules/transactions/.globals/redux/reducers';
import commonModules from 'Modules/.common/.globals/reducers';
import packages from 'Modules/packages/.globals/redux/reducers';
import keysFobs from 'Modules/keysFobs/.globals/redux/reducers';
import manufacturers from 'Modules/manufacturers/.globals/redux/reducers';
import users from 'Modules/users/.globals/redux/reducers';
import cloudLoginPage from 'Modules/loginPage/.globals/redux/reducers';
import reports from 'Modules/reports/.globals/redux/reducers';
import importP4 from 'Modules/importP4/.globals/redux/reducers';
import importAccount from 'Modules/importAccount/.globals/redux/reducers';
import dashboard from 'Modules/dashboard/.globals/redux/reducers';
import alertTypes from 'Modules/alertTypes/.globals/redux/reducers';
import scheduledActions from 'Modules/scheduledActions/.globals/redux/reducers';
import events from 'Modules/events/.globals/redux/reducers';
import unsubscribedContacts from 'Modules/unsubscribedContacts/.globals/redux/reducers';
import simProviders from 'Modules/simProviders/.globals/redux/reducers';
import simProviderAccounts from 'Modules/simProviderAccounts/.globals/redux/reducers';
import smsSystems from 'Modules/smsSystems/.globals/redux/reducers';
import dealers from 'Modules/dealers/.globals/redux/reducers';
import maintenanceWarningEvents from 'Modules/maintenanceWarningEvents/redux/reducers';
import tags from 'Modules/tags/.globals/redux/reducers';
import brands from 'Modules/brands/.globals/redux/reducers';


const reducersModules = {
    ...core,
    ...accounts,
    ...devices,
    ...activities,
    ...rawData,
    ...pmUsers,
    ...vidfleet,
    ...transactions,
    ...commonModules,
    ...packages,
    ...keysFobs,
    ...manufacturers,
    ...users,
    ...cloudLoginPage,
    ...reports,
    ...importP4,
    ...importAccount,
    ...dashboard,
    ...alertTypes,
    ...scheduledActions,
    ...events,
    ...unsubscribedContacts,
    ...simProviders,
    ...simProviderAccounts,
    ...smsSystems,
    ...dealers,
    ...maintenanceWarningEvents,
    ...tags,
    ...brands,
};

const reducers = combineReducers(reducersModules);

export default reducers;